module.exports = __webpack_public_path__ + "/login_ui/img/fj-86131889c246aacd5ed649e1a04950e8.svg";